import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
const cx = classNames.bind();
function Fieldset({ sm, children, flex, fieldsetStyle }) {
    return (
        <fieldset
            className={cx('form-group border p-4 border border-info ' + (sm && 'col-sm-' + sm), {
                'd-flex': flex,
            })}
            style={{
                borderRadius: ' 1rem',
                ...fieldsetStyle,
            }}
        >
            {children}
        </fieldset>
    );
}

const Legend = ({ children }) => {
    return <legend className="w-auto px-2">{children}</legend>;
};

Fieldset.Legend = Legend;

/*
 *****************************PropTypes *****************************
 */
Fieldset.defaultProps = {
    flex: false,
    fieldsetStyle: {},
    sm: '',
};
Fieldset.propTypes = {
    children: PropTypes.node.isRequired,
    sm: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    flex: PropTypes.bool,
    fieldsetStyle: PropTypes.object,
};
Legend.propTypes = {
    children: PropTypes.string.isRequired,
};

export default Fieldset;
